module.exports = __webpack_public_path__ + "/public/font/ae6b6e25250d3b7f8a8725a0193e07b2.woff2";